<template>
    <o-wrapper 
        class="o-project-wrapper" 
        :projectUuid="projectUuid" 
        :onGetProjects="onGetProjects"
        :needTranslateStat="needTranslateStat"
    >
        <template #side-menu><o-project-nav :projectUuid="projectUuid" :onGetProjects="onGetProjects"/></template>
        <template #content><slot/></template>
    </o-wrapper>
</template>

<script>
import OWrapper from '@organisms2/o-wrapper'
import OProjectNav from '@organisms2/o-project-nav'

export default {
    name: 'OProjectWrapper',
    components: {
        OWrapper,
        OProjectNav
    },
    props: {
        projectUuid: {
            type: String,
            required: true
        },
        onGetProjects: {
            type: Function
        },
        needTranslateStat: {
            type: Object
        }
    },
}
</script>

<style lang="scss" scoped>
@import 'theme';
</style>
